export enum SectionIds {
  skills = "skills",
  projects = "projects",
  contact = "contact",
}
